import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { LoadingState } from '../../utilities/constants';
import { createFavReportApi, fetchFavouriteReportsApi, removeFavReportApi } from '../add-to-favourite/favReportsApi';

export const fetchFavReports = createAsyncThunk('favReports/fetchfavReports', async (payload) => {
  try {
    const response = await fetchFavouriteReportsApi(payload.orgId, payload.usrId);
    return response;
  } catch (error) {
    throw error;
  }
});

export const createFavReport = createAsyncThunk('favReports/createFavReport', async (payload, { dispatch }) => {
  try {
    const { orgId, usrId, combinedData } = payload;
    await createFavReportApi(orgId, usrId, combinedData);
    dispatch(fetchFavReports({ orgId, usrId }));
  } catch (error) {
    toast.error(error.message);
    throw error;
  }
});

export const removeFavReport = createAsyncThunk('favReports/remove-favReport', async (payload, { dispatch }) => {
  try {
    const { orgId, usrId, data } = payload;
    await removeFavReportApi(orgId, usrId, data);
    dispatch(fetchFavReports({ orgId, usrId }));
  } catch (error) {
    toast.error(error.message);
    throw error;
  }
});

const favouriteRportsSlice = createSlice({
  name: 'favouriteReports',
  initialState: {
    favReports: [],
    status: LoadingState.idle,
    error: null
  },
  reducers: {},
  extraReducers: {
    [fetchFavReports.pending]: (state) => {
      state.status = LoadingState.loading;
    },
    [fetchFavReports.fulfilled]: (state, action) => {
      state.status = LoadingState.succeeded;
      state.favReports = action.payload;
    },
    [fetchFavReports.rejected]: (state, action) => {
      state.status = LoadingState.failed;
      state.error = action.error.message;
    },
  }
});

export default favouriteRportsSlice.reducer;
